import { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';

function format(ms) {
  const total = Math.floor(ms / 1000);
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (d > 0) return `${d}d ${pad(h)}h ${pad(m)}min`;
  if (h > 0) return `${h}h ${pad(m)}min ${pad(s)}s`;
  return `${m}min ${pad(s)}s`;
}

/** Contagem regressiva da campanha: mostra quanto falta para começar ou para terminar. */
export function Countdown({ c }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!c?.ends_at) return null;
  const start = c.starts_at ? new Date(c.starts_at).getTime() : null;
  const end = new Date(c.ends_at).getTime();

  let text = null;
  if (c.status === 'agendada' && start && start > now) {
    text = `Começa em ${format(start - now)}`;
  } else if (['agendada', 'ativa'].includes(c.status) && (!start || start <= now)) {
    text = end > now ? `Termina em ${format(end - now)}` : 'Campanha encerrada';
  }
  if (!text) return null;

  return (
    <span className="inline-flex items-center gap-1.5 rounded-md border border-white/10 bg-white/5 px-2 py-1 font-mono text-[11px] text-foreground" data-testid="ad-countdown">
      <Timer className="h-3 w-3 text-primary" /> {text}
    </span>
  );
}